// ตัวช่วยให้ท่าทางของเมาส์ใช้ได้บนจอสัมผัส (คอมไม่กระทบ — ยังใช้ event เมาส์เดิม):
//  - ctxProps: "คลิกขวา" = กดค้าง ~0.5 วินาที (ตารางเงินเดือน/ตารางโครงการใช้คลิกขวาเปิดรายละเอียด/ไม่รวมยอด)
//    มือถือไม่มีคลิกขวา (Android บางเครื่องยิง contextmenu เองตอนกดค้าง แต่ iOS Safari ไม่ยิง)
//  - doubleTapProps: "ดับเบิลคลิก" = แตะสองครั้งติดกัน (iOS Safari ไม่ยิง dblclick ให้เองเสมอไป)
const LONG_PRESS_MS = 500;
const MOVE_TOLERANCE_PX = 10;
const DEDUPE_MS = 800; // Android ยิงทั้ง contextmenu และ long-press → เปิดครั้งเดียว

// event จำลอง — มี currentTarget/target เผื่อ handler ที่ใช้เป็น anchor ของ Popover (เช่น e.currentTarget)
const fakeEventFor = (el) => ({
  currentTarget: el, target: el, preventDefault() {}, stopPropagation() {},
});

const cancel = (el) => {
  if (el?.__lp?.timer) clearTimeout(el.__lp.timer);
  if (el) el.__lp = null;
};

// handler: (e) => void — รับ event ที่มี preventDefault ได้ (เหมือน onContextMenu เดิม)
export const ctxProps = (handler) => {
  const run = (el, e) => {
    const now = Date.now();
    if (el.__ctxAt && now - el.__ctxAt < DEDUPE_MS) return;
    el.__ctxAt = now;
    handler(e);
  };

  return {
    onContextMenu: (e) => {
      const el = e.currentTarget;
      // contextmenu ที่ตามมาหลัง long-press ของเรา → กลืนไว้ ไม่เปิดซ้ำ
      if (el.__ctxAt && Date.now() - el.__ctxAt < DEDUPE_MS) {
        e.preventDefault();
        return;
      }
      el.__ctxAt = Date.now();
      handler(e);
    },
    onTouchStart: (e) => {
      const el = e.currentTarget;
      const touch = e.touches[0];
      cancel(el);
      el.__lp = {
        x: touch.clientX,
        y: touch.clientY,
        fired: false,
        timer: setTimeout(() => {
          if (!el.__lp) return;
          el.__lp.fired = true;
          run(el, fakeEventFor(el));
        }, LONG_PRESS_MS),
      };
    },
    onTouchMove: (e) => {
      const el = e.currentTarget;
      const lp = el.__lp;
      if (!lp || lp.fired) return;
      const touch = e.touches[0];
      if (
        Math.abs(touch.clientX - lp.x) > MOVE_TOLERANCE_PX ||
        Math.abs(touch.clientY - lp.y) > MOVE_TOLERANCE_PX
      ) {
        cancel(el);
      }
    },
    onTouchEnd: (e) => {
      const el = e.currentTarget;
      const fired = el.__lp?.fired;
      cancel(el);
      // กดค้างจนเปิดหน้าต่างแล้ว → กันไม่ให้ปล่อยนิ้วแล้วกลายเป็นการแตะ (click) ซ้ำ
      if (fired && e.cancelable) e.preventDefault();
    },
    onTouchCancel: (e) => cancel(e.currentTarget),
  };
};

const DOUBLE_TAP_MS = 320;
const TAP_MOVE_PX = 10; // ขยับนิ้วเกินนี้ = เลื่อนหน้า ไม่นับเป็นการแตะ
const DOUBLE_TAP_DISTANCE_PX = 30;

// handler: (e) => void — e จำลองมี target (ตรวจ e.target.closest(...) ได้เหมือน dblclick จริง)
// แตะครั้งที่สองจะ preventDefault เพื่อกัน click ที่ตามมาไปเริ่มการกระทำของคลิกเดี่ยวซ้ำ
// (บนเมาส์ dblclick ยิงหลัง click ที่สอง แต่บนจอสัมผัสเราจับได้ก่อน click)
export const doubleTapProps = (handler) => ({
  onTouchStart: (e) => {
    const touch = e.touches[0];
    e.currentTarget.__tapStart = { x: touch.clientX, y: touch.clientY };
  },
  onTouchEnd: (e) => {
    const el = e.currentTarget;
    const touch = e.changedTouches[0];
    const start = el.__tapStart;
    if (
      !start ||
      Math.abs(touch.clientX - start.x) > TAP_MOVE_PX ||
      Math.abs(touch.clientY - start.y) > TAP_MOVE_PX
    ) {
      el.__lastTap = null;
      return;
    }
    const now = Date.now();
    const last = el.__lastTap;
    if (
      last &&
      now - last.t < DOUBLE_TAP_MS &&
      Math.abs(touch.clientX - last.x) < DOUBLE_TAP_DISTANCE_PX &&
      Math.abs(touch.clientY - last.y) < DOUBLE_TAP_DISTANCE_PX
    ) {
      el.__lastTap = null;
      if (e.cancelable) e.preventDefault();
      handler({ target: e.target, preventDefault() {}, stopPropagation() {} });
      return;
    }
    el.__lastTap = { t: now, x: touch.clientX, y: touch.clientY };
  },
});

export default ctxProps;
